/* ========================================
   SEARCH OVERLAY - from Lovable SearchOverlay.tsx
   Shows all products on open, instant client-side filter
   ======================================== */

(function () {
  'use strict';

  function init() {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;

    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var dataEl = overlay.querySelector('[data-search-products]');
    var debounceTimer = null;

    var allProducts = [];
    try { allProducts = JSON.parse(dataEl.textContent); } catch (e) { allProducts = []; }

    /* ---------- Open / close ---------- */
    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (input) input.value = '';
      render(allProducts, '');
      setTimeout(function () { if (input) input.focus(); }, 50);
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('search:open', open);
    overlay.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    /* ---------- Client-side filter ---------- */
    function filterProducts(term) {
      var t = (term || '').trim().toLowerCase();
      if (!t) return allProducts;
      return allProducts.filter(function (p) {
        return (p.title && p.title.toLowerCase().indexOf(t) !== -1) ||
          (p.type && p.type.toLowerCase().indexOf(t) !== -1) ||
          (p.vendor && p.vendor.toLowerCase().indexOf(t) !== -1) ||
          (p.sku && p.sku.toLowerCase().indexOf(t) !== -1);
      });
    }

    function render(products, term) {
      if (products.length === 0) {
        results.innerHTML = '<div class="search-overlay__hint">No products match your search' +
          (term ? ' for "' + escapeHtml(term) + '"' : '') + '.</div>';
        return;
      }
      var html = '<div class="search-overlay__count">' + products.length + '</div>';
      html += '<ul class="search-overlay__grid">';
      products.slice(0, 24).forEach(function (p) {
        html += '<li class="search-overlay__item">' +
          '<a href="' + p.url + '" class="search-overlay__link">' +
          '<div class="search-overlay__item-top">' +
          '<span class="search-overlay__item-title">' + escapeHtml(p.title) + '</span>' +
          (p.sku ? '<span class="search-overlay__item-sku">' + escapeHtml(p.sku) + '</span>' : '') +
          '</div>' +
          '<div class="search-overlay__item-img-wrap">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" class="search-overlay__item-img">' : '') +
          '</div>' +
          '<div class="search-overlay__item-bottom">' +
          '<span>' + escapeHtml(p.type || p.vendor || '') + '</span>' +
          '</div>' +
          '</a></li>';
      });
      html += '</ul>';
      results.innerHTML = html;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str == null ? '' : str;
      return div.innerHTML;
    }

    /* ---------- Input handler (debounced, instant feel) ---------- */
    if (input) {
      input.addEventListener('input', function () {
        var term = input.value;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          render(filterProducts(term), term);
        }, 120);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var first = results.querySelector('.search-overlay__link');
          if (first) window.location.href = first.getAttribute('href');
        }
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
